import { render, staticRenderFns } from "./swFAQ.vue?vue&type=template&id=6b57b584&scoped=true&"
import script from "./swFAQ.vue?vue&type=script&lang=js&"
export * from "./swFAQ.vue?vue&type=script&lang=js&"
import style0 from "./swFAQ.vue?vue&type=style&index=0&id=6b57b584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b57b584",
  null
  
)

export default component.exports